import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const getUserById = async (userId) => {
  const response = await API.graphql({
    query: getUserByIdQuery,
    variables: { id: userId }
  })
  return response?.data
}

const getUserByIdQuery = gql`
  query GetUserById($id: ID!) {
    getUserById(id: $id) {
      id
      firstName
      lastName
      createdAt
      avatar
      defaultWorkspaceId
      membershipCollection {
        total
        items {
          workspace {
            id
            logo
            name
            description
            createdAt
          }
        }
      }
    }
  }
`

export { getUserById, getUserByIdQuery }
export default getUserById
